import { z } from 'zod'
import { ParkingCardVehicleTypeEnum } from '~/shared/config/enums'
import {
  dateSchema,
  enumOptionSchema,
  parkingCardNumberSchema,
  priceRequiredScheme,
  stsDocumentSeriesSchema,
} from '~/shared/lib/schemas'
import { Car } from './car'
import { ApiModel } from './core'
import { StsDocumentAttributes } from './stsDocument'

const attributeSchema = z.object({
  series: stsDocumentSeriesSchema,
  number: parkingCardNumberSchema,
  paidAmount: priceRequiredScheme,
  paymentDate: dateSchema,
  expirationDate: dateSchema,
  vehicleType: enumOptionSchema(ParkingCardVehicleTypeEnum),

  files: z
    .object({
      id: z.string(),
      name: z.string(),
      filepath: z.string().url(),
      preview: z.string().url(),
    })
    .array()
    .optional(),
})

const schema = z
  .object({
    createdAt: dateSchema,
    updatedAt: dateSchema.optional(),
    isActive: z.boolean().optional(),
  })
  .merge(attributeSchema)

export type ParkingCardAttributes = z.infer<typeof schema>

export class ParkingCard extends ApiModel<typeof schema> {
  static jsonApiType = 'parking-cards'

  static schema = schema

  setCar(id: UniqueId) {
    this.setRelation('car', new Car({}, id))
  }

  getCreatedAt(): string {
    return this.getAttribute('createdAt')
  }

  getFiles(): StsDocumentAttributes['files'] {
    return this.getAttribute('files')
  }

  getPaidAmount(): number {
    return this.getAttribute('paidAmount')
  }
}
